export enum WorkbenchTypeEnum {
  plan = 1,
  edge = 2,
  cutaway = 3,
  jamb = 4,
  assembly = 5,
  splashback = 6,
  cutting = 7,
  polish = 8,
  package = 9,
}
